<template>
  <dialog-custom
    :is-dialog-open="isFileListDialogOpen"
    max-width="800"
    :close-dialog="closeDialog"
    :dialog-title="dialogTitle"
  >
    <v-form class="multi-col-validation">
      <template v-if="files.length">
        <v-row
          v-for="(row, rowIndex) in filesDivididosEmRowsDeDuasColumns"
          :key="rowIndex"
        >
          <v-col
            v-for="(file, fileIndex) in row"
            :key="fileIndex"
            cols="12"
            :md="row.length === 1 ? 12 : 6"
          >
            <file-list-item :file="file" />
          </v-col>
        </v-row>
      </template>

      <div
        v-else
        class="d-flex justify-center"
      >
        <span>{{ noFilesMessage }}</span>
      </div>
    </v-form>
  </dialog-custom>
</template>

<script>
import { computed } from '@vue/composition-api'
import DialogCustom from '../dialog/Dialog.vue'
import FileListItem from './FileListItem.vue'
import useDialog from '@/composables/useDialog'

export default {
  components: {
    DialogCustom,
    FileListItem,
  },

  props: {
    dialogTitle: {
      type: String,
      default: 'Arquivos',
    },
    isFileListDialogOpen: {
      type: Boolean,
      required: true,
    },
    files: {
      type: Array,
      required: true,
    },
    noFilesMessage: {
      type: String,
      default: 'Nenhum arquivo disponível',
    },
  },

  setup(props, { emit }) {
    const { closeDialog } = useDialog(emit, 'is-file-list-dialog-open')

    const filesDivididosEmRowsDeDuasColumns = computed(() => {
      const result = []

      for (let i = 0; i < props.files.length; i += 2) {
        const subArray = props.files.slice(i, i + 2)
        result.push(subArray)
      }

      return result
    })

    return {
      closeDialog,
      filesDivididosEmRowsDeDuasColumns,
    }
  },
}
</script>
